import React, { useState } from "react";
import styles from "./Contact.module.css";
import { useNavigate } from "react-router-dom";

const FORMSPARK_ACTION_URL = "https://submit-form.com/1mncuMmZl"; // Reemplaza con tu Form ID

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSending, setIsSending] = useState(false);
  const [messageSent, setMessageSent] = useState(false);
  const navigate = useNavigate();

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    try {
      await fetch(FORMSPARK_ACTION_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });
      setMessageSent(true);
      setIsSending(false);

      // Redirigir a la página de inicio después de 3 segundos
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } catch (error) {
      console.error("Error enviando el formulario", error);
      setIsSending(false);
    }
  };

  return (
    <div className={styles.capa}>
      <div name="Contacto" className={styles.contact}>
        <h2>Contacta con nosotros</h2>
        <p className={styles.contactText}>
          Puedes contactarnos mediante el formulario a continuación o enviando un correo electrónico a <a href="mailto:info@bonfertech.com">info@bonfertech.com</a>.
        </p>

        {messageSent ? (
          <div className={styles.successMessage}>
            <p>Se ha enviado correctamente tu mensaje, en breve nos pondremos en contacto contigo.</p>
          </div>
        ) : (
          <form className={styles.form} onSubmit={onSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="name" className={styles.label}>
                Nombre
              </label>
              <input
                id="name"
                name="name"
                className={styles.input}
                type="text"
                required
                value={formData.name}
                onChange={onChange} // Añadir onChange para actualizar el estado
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="email" className={styles.label}>
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                className={styles.input}
                required
                value={formData.email}
                onChange={onChange} // Añadir onChange para actualizar el estado
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="message" className={styles.label}>
                Mensaje
              </label>
              <textarea
                id="message"
                name="message"
                className={styles.textArea}
                required
                value={formData.message}
                onChange={onChange} // Añadir onChange para actualizar el estado
              />
            </div>

            <button
              type="submit"
              className={styles.submitButton}
              disabled={isSending}
            >
              {isSending ? (
                <div className={styles.spinner}></div>
              ) : (
                "Enviar"
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Contact;
